import React from "react"
import { useFormContext } from "react-hook-form"

import { useEvent } from "shared/lib/useEvent"

import { ClarificationRequestForm } from "entities/clarification-requests/ui/ClarificationRequestForm"
import { RoomFormData } from "features/room-management/types/RoomFormData"

import { useRoomFormContext } from "../contexts/RoomFormContext"

export const RoomFormClarificationRequest = React.memo(() => {
  const { isReadonly, clarificationRequest } = useRoomFormContext()
  const cr = clarificationRequest?.data.clarificationRequest
  const hasCR = !!cr?.data
  const lastUpdatedByMember =
    clarificationRequest?.data.meta.lastUpdatedByMember ?? null

  const { setValue } = useFormContext<RoomFormData>()

  const handleDismiss = useEvent(() => {
    clarificationRequest?.handlers.onDelete?.()
    setValue("clarificationRequest.content", null)
  })

  return (
    <ClarificationRequestForm.Root
      clarificationRequest={cr?.data ?? null}
      isLoading={cr?.isLoading}
      lastUpdatedByMember={lastUpdatedByMember}
    >
      {hasCR ? <ClarificationRequestForm.UpdatedAt /> : null}
      <ClarificationRequestForm.TextArea
        name="clarificationRequest.content"
        readonly={isReadonly}
      />
      {hasCR && isReadonly && clarificationRequest?.handlers.onDelete ? (
        <ClarificationRequestForm.DismissButton onDismiss={handleDismiss} />
      ) : null}
      {!isReadonly && clarificationRequest?.data.meta.shouldShowHint && (
        <ClarificationRequestForm.Hint
          onClose={clarificationRequest.handlers.onHintClose}
        />
      )}
    </ClarificationRequestForm.Root>
  )
})

RoomFormClarificationRequest.displayName = "RoomFormClarificationRequest"
